import {
  GET_TASKS_CRMIT_LIST,
  GET_TASKS_CRMIT_LIST_SUCCESS,
  GET_TASKS_CRMIT_LIST_ERROR,
  CREATE_TASK_CRMIT,
  CREATE_TASK_CRMIT_SUCCESS,
  CREATE_TASK_CRMIT_ERROR,
  GET_TASK_CRMIT,
  GET_TASK_CRMIT_SUCCESS,
  GET_TASK_CRMIT_ERROR,
  UPDATE_TASK_CRMIT,
  UPDATE_TASK_CRMIT_SUCCESS,
  UPDATE_TASK_CRMIT_ERROR,
  CLAIM_TASK_CRMIT,
  CLAIM_TASK_CRMIT_SUCCESS,
  CLAIM_TASK_CRMIT_ERROR,
  DELETE_TASK_CRMIT,
  DELETE_TASK_CRMIT_SUCCESS,
  DELETE_TASK_CRMIT_ERROR,
  GET_TASK_STATUS_LIST_CRMIT,
  GET_TASK_STATUS_LIST_CRMIT_SUCCESS,
  GET_TASK_STATUS_LIST_CRMIT_ERROR,
  SEARCH_TASK_LIST,
  SEARCH_TASK_LIST_SUCCESS,
  SEARCH_TASK_LIST_ERROR,
  GET_TASK_TYPE_LIST,
  GET_TASK_TYPE_LIST_SUCCESS,
  GET_TASK_TYPE_LIST_ERROR,
  GET_TASK_PRIORITY_LIST,
  GET_TASK_PRIORITY_LIST_SUCCESS,
  GET_TASK_PRIORITY_LIST_ERROR,
  GET_SINGLE_TASK_NOTE_DATA,
  GET_SINGLE_TASK_NOTE_DATA_SUCCESS,
  GET_SINGLE_TASK_NOTE_DATA_ERROR,
  CREATE_SINGLE_TASK_NOTE,
  CREATE_SINGLE_TASK_NOTE_SUCCESS,
  CREATE_SINGLE_TASK_NOTE_ERROR,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR,
  SEARCH_TASK_TIME_ENTRY_LIST,
  SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS,
  SEARCH_TASK_TIME_ENTRY_LIST_ERROR,
  CREATE_TASK_TIME_ENTRY,
  CREATE_TASK_TIME_ENTRY_SUCCESS,
  CREATE_TASK_TIME_ENTRY_ERROR,
  ADD_NEW_TASK_STATUS,
  ADD_NEW_TASK_STATUS_SUCCESS,
  ADD_NEW_TASK_STATUS_ERROR,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_STATUS_ERROR,
  DELETE_TASK_STATUS,
  DELETE_TASK_STATUS_SUCCESS,
  DELETE_TASK_STATUS_ERROR,
  ADD_NEW_TASK_TYPE,
  ADD_NEW_TASK_TYPE_SUCCESS,
  ADD_NEW_TASK_TYPE_ERROR,
  UPDATE_TASK_TYPE,
  UPDATE_TASK_TYPE_SUCCESS,
  UPDATE_TASK_TYPE_ERROR,
  DELETE_TASK_TYPE,
  DELETE_TASK_TYPE_SUCCESS,
  DELETE_TASK_TYPE_ERROR,
  ADD_NEW_TASK_PRIORITY,
  ADD_NEW_TASK_PRIORITY_SUCCESS,
  ADD_NEW_TASK_PRIORITY_ERROR,
  UPDATE_TASK_PRIORITY,
  UPDATE_TASK_PRIORITY_SUCCESS,
  UPDATE_TASK_PRIORITY_ERROR,
  DELETE_TASK_PRIORITY,
  DELETE_TASK_PRIORITY_SUCCESS,
  DELETE_TASK_PRIORITY_ERROR,
  GET_TASK_RECENT_ACTIVITY_LIST,
  GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_TASK_RECENT_ACTIVITY_LIST_ERROR,
  GET_TASK_CHANGE_LOG_LIST,
  GET_TASK_CHANGE_LOG_LIST_SUCCESS,
  GET_TASK_CHANGE_LOG_LIST_ERROR,
  GET_TASK_TEMPLATE_LIST,
  GET_TASK_TEMPLATE_LIST_SUCCESS,
  GET_TASK_TEMPLATE_LIST_ERROR,
  GET_TASK_TEMPLATE_DATA,
  GET_TASK_TEMPLATE_DATA_SUCCESS,
  GET_TASK_TEMPLATE_DATA_ERROR,
  CREATE_TASK_TEMPLATE,
  CREATE_TASK_TEMPLATE_SUCCESS,
  CREATE_TASK_TEMPLATE_ERROR,
  UPDATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE_SUCCESS,
  UPDATE_TASK_TEMPLATE_ERROR,
  DELETE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE_SUCCESS,
  DELETE_TASK_TEMPLATE_ERROR,
  SEARCH_TASK_TEMPLATE_LIST,
  SEARCH_TASK_TEMPLATE_LIST_SUCCESS,
  SEARCH_TASK_TEMPLATE_LIST_ERROR,
  GET_TASK_ATTACHMENT_LIST,
  GET_TASK_ATTACHMENT_LIST_SUCCESS,
  GET_TASK_ATTACHMENT_LIST_ERROR,
  SEARCH_TASK_ATTACHMENT_LIST,
  SEARCH_TASK_ATTACHMENT_LIST_SUCCESS,
  SEARCH_TASK_ATTACHMENT_LIST_ERROR,
  GET_TASK_ATTACHMENT_DATA,
  GET_TASK_ATTACHMENT_DATA_SUCCESS,
  GET_TASK_ATTACHMENT_DATA_ERROR,
  DELETE_TASK_ATTACHMENT,
  DELETE_TASK_ATTACHMENT_SUCCESS,
  DELETE_TASK_ATTACHMENT_ERROR,
  TASK_USE_HEART_BEAT_LOCALLY,
  TASK_USE_HEART_BEAT_LOCALLY_SUCCESS,
  TASK_USE_HEART_BEAT_LOCALLY_ERROR,
} from "./actionType";

// Action for TaskCrmIt List and CRUD

// TaskCrmIt List
export const getTasksCrmITList = () => ({
  type: GET_TASKS_CRMIT_LIST,
});

export const getTasksCrmITListSuccess = (data) => ({
  type: GET_TASKS_CRMIT_LIST_SUCCESS,
  payload: data,
});

export const getTasksCrmITListError = (error) => ({
  type: GET_TASKS_CRMIT_LIST_ERROR,
  payload: error,
});

// TaskCrmIt Create
export const createTaskCrmIT = (data) => ({
  type: CREATE_TASK_CRMIT,
  payload: data,
});

export const createTaskCrmITSuccess = (data) => ({
  type: CREATE_TASK_CRMIT_SUCCESS,
  payload: data,
});

export const createTaskCrmITError = (error) => ({
  type: CREATE_TASK_CRMIT_ERROR,
  payload: error,
});

// TaskCrmIT Read

export const getTaskCrmIT = (id) => ({
  type: GET_TASK_CRMIT,
  payload: id,
});

export const getTaskCrmITSuccess = (data) => ({
  type: GET_TASK_CRMIT_SUCCESS,
  payload: data,
});

export const getTaskCrmITError = (error) => ({
  type: GET_TASK_CRMIT_ERROR,
  payload: error,
});

// TaskCrmIt Update

export const updateTaskCrmIT = (data) => ({
  type: UPDATE_TASK_CRMIT,
  payload: data,
});

export const updateTaskCrmITSuccess = (data) => ({
  type: UPDATE_TASK_CRMIT_SUCCESS,
  payload: data,
});

export const updateTaskCrmITError = (error) => ({
  type: UPDATE_TASK_CRMIT_ERROR,
  payload: error,
});

// TaskCrmIt Claim (member claims a pooled task; data = { Task_Id })

export const claimTaskCrmIT = (data) => ({
  type: CLAIM_TASK_CRMIT,
  payload: data,
});

export const claimTaskCrmITSuccess = (data) => ({
  type: CLAIM_TASK_CRMIT_SUCCESS,
  payload: data,
});

export const claimTaskCrmITError = (error) => ({
  type: CLAIM_TASK_CRMIT_ERROR,
  payload: error,
});

// TaskCrmIt Delete

export const deleteTaskCrmIT = (id) => ({
  type: DELETE_TASK_CRMIT,
  payload: id,
});

export const deleteTaskCrmITSuccess = (data) => ({
  type: DELETE_TASK_CRMIT_SUCCESS,
  payload: data,
});

export const deleteTaskCrmITError = (error) => ({
  type: DELETE_TASK_CRMIT_ERROR,
  payload: error,
});

// Get Tasks Satuts List CRMIT
export const getTaskStatusListCrmIT = () => ({
  type: GET_TASK_STATUS_LIST_CRMIT,
});

export const getTaskStatusListCrmITSuccess = (data) => ({
  type: GET_TASK_STATUS_LIST_CRMIT_SUCCESS,
  payload: data,
});

export const getTaskStatusListCrmITError = (error) => ({
  type: GET_TASK_STATUS_LIST_CRMIT_ERROR,
  payload: error,
});

// Search Task List

export const searchTaskList = (data) => ({
  type: SEARCH_TASK_LIST,
  payload: data,
});

export const searchTaskListSuccess = (data) => ({
  type: SEARCH_TASK_LIST_SUCCESS,
  payload: data,
});

export const searchTaskListError = (error) => ({
  type: SEARCH_TASK_LIST_ERROR,
  payload: error,
});

// Get Task Type List

export const getTaskTypeList = () => ({
  type: GET_TASK_TYPE_LIST,
});

export const getTaskTypeListSuccess = (data) => ({
  type: GET_TASK_TYPE_LIST_SUCCESS,
  payload: data,
});

export const getTaskTypeListError = (error) => ({
  type: GET_TASK_TYPE_LIST_ERROR,
  payload: error,
});

// Get Task Priority List

export const getTaskPriorityList = () => ({
  type: GET_TASK_PRIORITY_LIST,
});

export const getTaskPriorityListSuccess = (data) => ({
  type: GET_TASK_PRIORITY_LIST_SUCCESS,
  payload: data,
});

export const getTaskPriorityListError = (error) => ({
  type: GET_TASK_PRIORITY_LIST_ERROR,
  payload: error,
});

//  Get Single Task Note Data

export const getSingleTaskNoteData = (id) => ({
  type: GET_SINGLE_TASK_NOTE_DATA,
  payload: id,
});

export const getSingleTaskNoteDataSuccess = (data) => ({
  type: GET_SINGLE_TASK_NOTE_DATA_SUCCESS,
  payload: data,
});

export const getSingleTaskNoteDataError = (error) => ({
  type: GET_SINGLE_TASK_NOTE_DATA_ERROR,
  payload: error,
});

// Create Single Task Note

export const createSingleTaskNote = (data) => ({
  type: CREATE_SINGLE_TASK_NOTE,
  payload: data,
});

export const createSingleTaskNoteSuccess = (data) => ({
  type: CREATE_SINGLE_TASK_NOTE_SUCCESS,
  payload: data,
});

export const createSingleTaskNoteError = (error) => ({
  type: CREATE_SINGLE_TASK_NOTE_ERROR,
  payload: error,
});

// Search Single Job Task List For Timer

export const searchSingleJobTaskListForTimer = (data) => ({
  type: SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER,
  payload: data,
});

export const searchSingleJobTaskListForTimerSuccess = (data) => ({
  type: SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS,
  payload: data,
});

export const searchSingleJobTaskListForTimerError = (error) => ({
  type: SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR,
  payload: error,
});

// Search Task Time Entry List

export const searchTaskTimeEntryList = (data) => ({
  type: SEARCH_TASK_TIME_ENTRY_LIST,
  payload: data,
});

export const searchTaskTimeEntryListSuccess = (data) => ({
  type: SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS,
  payload: data,
});

export const searchTaskTimeEntryListError = (error) => ({
  type: SEARCH_TASK_TIME_ENTRY_LIST_ERROR,
  payload: error,
});

// Create Task Time Entry

export const createTaskTimeEntry = (data) => ({
  type: CREATE_TASK_TIME_ENTRY,
  payload: data,
});

export const createTaskTimeEntrySuccess = (data) => ({
  type: CREATE_TASK_TIME_ENTRY_SUCCESS,
  payload: data,
});

export const createTaskTimeEntryError = (error) => ({
  type: CREATE_TASK_TIME_ENTRY_ERROR,
  payload: error,
});

// Add New Task Status

export const addNewTaskStatus = (data) => ({
  type: ADD_NEW_TASK_STATUS,
  payload: data,
});

export const addNewTaskStatusSuccess = (data) => ({
  type: ADD_NEW_TASK_STATUS_SUCCESS,
  payload: data,
});

export const addNewTaskStatusError = (error) => ({
  type: ADD_NEW_TASK_STATUS_ERROR,
  payload: error,
});

// Update Task Status

export const updateTaskStatus = (data) => ({
  type: UPDATE_TASK_STATUS,
  payload: data,
});

export const updateTaskStatusSuccess = (data) => ({
  type: UPDATE_TASK_STATUS_SUCCESS,
  payload: data,
});

export const updateTaskStatusError = (error) => ({
  type: UPDATE_TASK_STATUS_ERROR,
  payload: error,
});

// Delete Task Status

export const deleteTaskStatus = (id) => ({
  type: DELETE_TASK_STATUS,
  payload: id,
});

export const deleteTaskStatusSuccess = (data) => ({
  type: DELETE_TASK_STATUS_SUCCESS,
  payload: data,
});

export const deleteTaskStatusError = (error) => ({
  type: DELETE_TASK_STATUS_ERROR,
  payload: error,
});

// Add New Task Type

export const addNewTaskType = (data) => ({
  type: ADD_NEW_TASK_TYPE,
  payload: data,
});

export const addNewTaskTypeSuccess = (data) => ({
  type: ADD_NEW_TASK_TYPE_SUCCESS,
  payload: data,
});

export const addNewTaskTypeError = (error) => ({
  type: ADD_NEW_TASK_TYPE_ERROR,
  payload: error,
});

// Update Task Type

export const updateTaskType = (data) => ({
  type: UPDATE_TASK_TYPE,
  payload: data,
});

export const updateTaskTypeSuccess = (data) => ({
  type: UPDATE_TASK_TYPE_SUCCESS,
  payload: data,
});

export const updateTaskTypeError = (error) => ({
  type: UPDATE_TASK_TYPE_ERROR,
  payload: error,
});

// Delete Task Type

export const deleteTaskType = (id) => ({
  type: DELETE_TASK_TYPE,
  payload: id,
});

export const deleteTaskTypeSuccess = (data) => ({
  type: DELETE_TASK_TYPE_SUCCESS,
  payload: data,
});

export const deleteTaskTypeError = (error) => ({
  type: DELETE_TASK_TYPE_ERROR,
  payload: error,
});

// Add New Task Priority

export const addNewTaskPriority = (data) => ({
  type: ADD_NEW_TASK_PRIORITY,
  payload: data,
});

export const addNewTaskPrioritySuccess = (data) => ({
  type: ADD_NEW_TASK_PRIORITY_SUCCESS,
  payload: data,
});

export const addNewTaskPriorityError = (error) => ({
  type: ADD_NEW_TASK_PRIORITY_ERROR,
  payload: error,
});

// Update Task Priority

export const updateTaskPriority = (data) => ({
  type: UPDATE_TASK_PRIORITY,
  payload: data,
});

export const updateTaskPrioritySuccess = (data) => ({
  type: UPDATE_TASK_PRIORITY_SUCCESS,
  payload: data,
});

export const updateTaskPriorityError = (error) => ({
  type: UPDATE_TASK_PRIORITY_ERROR,
  payload: error,
});

// Delete Task Priority

export const deleteTaskPriority = (id) => ({
  type: DELETE_TASK_PRIORITY,
  payload: id,
});

export const deleteTaskPrioritySuccess = (data) => ({
  type: DELETE_TASK_PRIORITY_SUCCESS,
  payload: data,
});

export const deleteTaskPriorityError = (error) => ({
  type: DELETE_TASK_PRIORITY_ERROR,
  payload: error,
});

// Get Task Recent Activity List

export const getTaskRecentActivityList = (data) => ({
  type: GET_TASK_RECENT_ACTIVITY_LIST,
  payload: data,
});

export const getTaskRecentActivityListSuccess = (data) => ({
  type: GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS,
  payload: data,
});

export const getTaskRecentActivityListError = (error) => ({
  type: GET_TASK_RECENT_ACTIVITY_LIST_ERROR,
  payload: error,
});

// Get Task Change Log List (field-level change history)

export const getTaskChangeLogList = (data) => ({
  type: GET_TASK_CHANGE_LOG_LIST,
  payload: data,
});

export const getTaskChangeLogListSuccess = (data) => ({
  type: GET_TASK_CHANGE_LOG_LIST_SUCCESS,
  payload: data,
});

export const getTaskChangeLogListError = (error) => ({
  type: GET_TASK_CHANGE_LOG_LIST_ERROR,
  payload: error,
});

// Get Task Template List

export const getTaskTemplateList = () => ({
  type: GET_TASK_TEMPLATE_LIST,
});

export const getTaskTemplateListSuccess = (data) => ({
  type: GET_TASK_TEMPLATE_LIST_SUCCESS,
  payload: data,
});

export const getTaskTemplateListError = (error) => ({
  type: GET_TASK_TEMPLATE_LIST_ERROR,
  payload: error,
});

// Get Task Template Data
export const getTaskTemplateData = (id) => ({
  type: GET_TASK_TEMPLATE_DATA,
  payload: id,
});

export const getTaskTemplateDataSuccess = (data) => ({
  type: GET_TASK_TEMPLATE_DATA_SUCCESS,
  payload: data,
});

export const getTaskTemplateDataError = (error) => ({
  type: GET_TASK_TEMPLATE_DATA_ERROR,
  payload: error,
});

// Create Task Template
export const createTaskTemplate = (data) => ({
  type: CREATE_TASK_TEMPLATE,
  payload: data,
});

export const createTaskTemplateSuccess = (data) => ({
  type: CREATE_TASK_TEMPLATE_SUCCESS,
  payload: data,
});

export const createTaskTemplateError = (error) => ({
  type: CREATE_TASK_TEMPLATE_ERROR,
  payload: error,
});

// Update Task Template
export const updateTaskTemplate = (data) => ({
  type: UPDATE_TASK_TEMPLATE,
  payload: data,
});

export const updateTaskTemplateSuccess = (data) => ({
  type: UPDATE_TASK_TEMPLATE_SUCCESS,
  payload: data,
});

export const updateTaskTemplateError = (error) => ({
  type: UPDATE_TASK_TEMPLATE_ERROR,
  payload: error,
});

// Delete Task Template
export const deleteTaskTemplate = (id) => ({
  type: DELETE_TASK_TEMPLATE,
  payload: id,
});

export const deleteTaskTemplateSuccess = (data) => ({
  type: DELETE_TASK_TEMPLATE_SUCCESS,
  payload: data,
});

export const deleteTaskTemplateError = (error) => ({
  type: DELETE_TASK_TEMPLATE_ERROR,
  payload: error,
});

// Search Task Template List

export const searchTaskTemplateList = (data) => ({
  type: SEARCH_TASK_TEMPLATE_LIST,
  payload: data,
});

export const searchTaskTemplateListSuccess = (data) => ({
  type: SEARCH_TASK_TEMPLATE_LIST_SUCCESS,
  payload: data,
});

export const searchTaskTemplateListError = (error) => ({
  type: SEARCH_TASK_TEMPLATE_LIST_ERROR,
  payload: error,
});

// Get Task Attachment List

export const getTaskAttachmentList = () => ({
  type: GET_TASK_ATTACHMENT_LIST,
});

export const getTaskAttachmentListSuccess = (data) => ({
  type: GET_TASK_ATTACHMENT_LIST_SUCCESS,
  payload: data,
});

export const getTaskAttachmentListError = (error) => ({
  type: GET_TASK_ATTACHMENT_LIST_ERROR,
  payload: error,
});

// Search Task Attachment List

export const searchTaskAttachmentList = (data) => ({
  type: SEARCH_TASK_ATTACHMENT_LIST,
  payload: data,
});

export const searchTaskAttachmentListSuccess = (data) => ({
  type: SEARCH_TASK_ATTACHMENT_LIST_SUCCESS,
  payload: data,
});

export const searchTaskAttachmentListError = (error) => ({
  type: SEARCH_TASK_ATTACHMENT_LIST_ERROR,
  payload: error,
});

// Get Task Attachment Data
export const getTaskAttachmentData = (id) => ({
  type: GET_TASK_ATTACHMENT_DATA,
  payload: id,
});

export const getTaskAttachmentDataSuccess = (data) => ({
  type: GET_TASK_ATTACHMENT_DATA_SUCCESS,
  payload: data,
});

export const getTaskAttachmentDataError = (error) => ({
  type: GET_TASK_ATTACHMENT_DATA_ERROR,
  payload: error,
});

// Delete Task Attachment
export const deleteTaskAttachment = (id) => ({
  type: DELETE_TASK_ATTACHMENT,
  payload: id,
});

export const deleteTaskAttachmentSuccess = (data) => ({
  type: DELETE_TASK_ATTACHMENT_SUCCESS,
  payload: data,
});

export const deleteTaskAttachmentError = (error) => ({
  type: DELETE_TASK_ATTACHMENT_ERROR,
  payload: error,
});
// Task Use Heart Beat Locally

export const taskUseHeartBeatLocally = (data) => ({
  type: TASK_USE_HEART_BEAT_LOCALLY,
  payload: data,
});

export const taskUseHeartBeatLocallySuccess = (data) => ({
  type: TASK_USE_HEART_BEAT_LOCALLY_SUCCESS,
  payload: data,
});

export const taskUseHeartBeatLocallyError = (error) => ({
  type: TASK_USE_HEART_BEAT_LOCALLY_ERROR,
  payload: error,
});
